import { Record } from 'immutable';
import { filter, find, isEmpty, minBy } from 'lodash';

import { MONTHLY } from 'commons-vehicle/PurchaseMethods/constants/paymentFrequencies.js';
import * as PurchaseMethods from 'commons-vehicle/PurchaseMethods/constants/purchaseMethods.js';
import PURCHASE_METHODS from 'commons-vehicle/PurchaseMethods/constants/purchaseMethodsValues.js';

import Term from 'commons-vehicle/PurchaseMethods/models/TermModel.js';

const FinanceRecord = Record({
    purchaseMethod: PurchaseMethods.FINANCE,
    purchaseMethodValue: PURCHASE_METHODS.FINANCE,
    annualKMAllowed: 0,
    endTermKMCost: 0,
    selected: false,
    available: false,
    terms: [new Term()],
    selectedTerm: 0,
    kmPlans: [],
});

class Finance extends FinanceRecord {
    getSelectedTerm() {
        return find(this.terms, (term) => term.term === this.selectedTerm);
    }

    getBestPaymentTerm(maximumTerm) {
        return minBy(
            filter(this.terms, (filterTerm) => maximumTerm === 0 || filterTerm.term <= maximumTerm),
            (term) => term.calculatedPayment
        );
    }

    getBestPaymentFrequency() {
        if (isEmpty(this.terms)) {
            return MONTHLY;
        }
        return this.terms[0].getBestPaymentFrequency();
    }

    getAvailablePaymentFrequencies() {
        if (isEmpty(this.terms) || !this.terms[0].term) {
            return [];
        }
        return this.terms[0].getAvailablePaymentFrequencies();
    }

    getSelectedTermFrequency() {
        const selectedTerm = this.getSelectedTerm();
        return selectedTerm ? selectedTerm.getPaymentFrequency() : '';
    }

    getCalculatedPayment() {
        const selectedTerm = this.getSelectedTerm();
        return selectedTerm ? selectedTerm.calculatedPayment : 0;
    }

    getCashDown() {
        const selectedTerm = this.getSelectedTerm();
        return selectedTerm ? selectedTerm.cashDown : 0;
    }

    // I18n argument is the LocalService class to translate
    getKMPlansDropDownValues(I18n) {
        return this.kmPlans.map((kmPlan) => {
            return {
                value: kmPlan.annualKMAllowed,
                label: I18n.t('KM_PLANS.ANNUAL_KM_ALLOWED', { annualKMAllowed: kmPlan.annualKMAllowed }),
            };
        });
    }

    getKMPlan(annualKMAllowed) {
        return find(this.kmPlans, (kmPlan) => {
            return kmPlan.annualKMAllowed === annualKMAllowed;
        });
    }

    getDisclaimerParameters() {
        const selectedTerm = this.getSelectedTerm();
        if (!selectedTerm || !selectedTerm.term) {
            return null;
        }

        const { term, paymentFrequency, cashDown } = selectedTerm;

        return {
            purchaseMethod: this.purchaseMethodValue,
            cashDown,
            terms: [term],
            paymentFrequencies: [paymentFrequency],
        };
    }

    get hasValidTerms() {
        return this.terms.length > 0 && this.terms[0].payment > 0;
    }
}

export default Finance;
